import { config } from '@application/common/static-config';
const { AUTH_CLIENT_ID, AUTH_SCOPE, AUTHORITY, AUTH_REDIRECT_URI, AUTH_LOGOUT_REDIRECT_URI } = config;
export const msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID,
        authority: AUTHORITY,
        redirectUri: AUTH_REDIRECT_URI,
        postLogoutRedirectUri: AUTH_LOGOUT_REDIRECT_URI
    },
    system: {
        allowPlatformBroker: true
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    }
};
export const loginRequest = {
    scopes: [AUTH_SCOPE ?? '']
};
